export default {
  never: 'Never',
};
